export default __webpack_public_path__ + "static/icon-9-6-93f581d0be98b9696e2a8b2acaa8fc37.png";